import html2canvas from 'html2canvas';

/**
 * HTMLから画像を生成するmixin
 */
export default {
    data() {
        return {
            imageDataUrl: null,
        };
    },
    methods: {
        /**
         * HTMLエレメントを指定してキャプチャする
         * 
         * @param   {string} select (ex:body)
         * @returns {object} 画像ファイルのオブジェクト
         */
        capture: async function (select) {
            // キャプチャ対象の要素を指定
            const element = document.querySelector(select);

            // pngで画像データ生成
            await html2canvas(element).then((canvas) => {
                this.imageDataUrl = canvas.toDataURL('image/png');
            });

            // 画像データをファイルオブジェクトに変換して返す
            return this.base64ToFileObject();
        },
        /**
         * キャプチャ(Base64エンコード画像)をファイルオブジェクトに変換
         * 
         * @param   {string} filename
         * @returns {object}
         */
        base64ToFileObject: async function () {
            const response = await fetch(this.imageDataUrl);
            const blob = await response.blob();
            const file = new File([blob], 'captureimage.png', { type: 'image/png' });

            return file;
        }
    }
};
